import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Badge,
  Button,
  Spinner,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLayerGroup,
  faUsers,
  faFileAlt,
  faUserTie,
  faArrowLeft,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";

import "./plans.css";
import { CompanyService } from "Services/CompanyService";
import { toast } from "react-toastify";

const ViewPlan = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [plan, setPlan] = useState<any>(null);

  const getPlanDetails = async () => {
    try {
      const res = await CompanyService.getPlanDetails(id!);

      if (res.status === 200) {
        setPlan(res.data.data);
      }
    } catch (error) {
      toast.error("Failed to fetch plan details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPlanDetails();
  }, []);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!plan) return null;

  const users =
    plan.limits?.find((l: any) => l.key === "users")?.value || 0;

  const exams =
    plan.limits?.find((l: any) => l.key === "exams")?.value || 0;

  const proctors =
    plan.limits?.find((l: any) => l.key === "proctors")?.value || 0;

  return (
    <div className="plans-page">
      <Card className="shadow-sm border-0 plans-card">
        <Card.Body>

          {/* HEADER */}

          <div className="d-flex justify-content-between align-items-center mb-4">

            <div>

              <div className="d-flex align-items-center mb-2">

                <h4 className="fw-bold mb-0 me-3">
                  Plan Details
                </h4>

                <Badge className="plan-chip">
                  {plan.name}
                </Badge>

              </div>

              <small className="text-muted">
                Complete configuration of selected plan
              </small>

            </div>

            <Button variant="light" onClick={() => navigate(-1)}>
              <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
              Back
            </Button>

          </div>

          {/* OVERVIEW */}

          <Card className="mb-4 modal-section-card">

            <Card.Body>

              <h6 className="section-title mb-3">
                <FontAwesomeIcon icon={faLayerGroup} className="me-2" />
                Overview
              </h6>

              <Row>

                <Col md={2}>
                  <p className="label">Price</p>
                  <h5 className="value-highlight">
                    {plan.price === 0 ? "Free" : `₹${plan.price}`}
                  </h5>
                </Col>

                <Col md={2}>
                  <p className="label">Currency</p>
                  <p className="value">{plan.currency}</p>
                </Col>

                <Col md={2}>
                  <p className="label">Billing Cycle</p>
                  <p className="value">
                    <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                    {plan.billingCycle}
                  </p>
                </Col>

                <Col md={2}>
                  <p className="label">Status</p>

                  <Badge
                    bg={plan.status === "active" ? "success" : "danger"}
                    className="px-3 py-2"
                  >
                    {plan.status}
                  </Badge>

                </Col>

                <Col md={2}>
                  <p className="label">Free Plan</p>
                  <p className="value">
                    {plan.isFree ? "Yes" : "No"}
                  </p>
                </Col>

                <Col md={2}>
                  <p className="label">Slug</p>
                  <p className="value">{plan.slug}</p>
                </Col>

              </Row>

              <Row className="mt-3">

                <Col md={3}>
                  <p className="label">Created On</p>
                  <p className="value">
                    {new Date(plan.createdAt).toLocaleDateString()}
                  </p>
                </Col>

                <Col md={3}>
                  <p className="label">Updated On</p>
                  <p className="value">
                    {new Date(plan.updatedAt).toLocaleDateString()}
                  </p>
                </Col>

                <Col md={6}>
                  <p className="label">Plan ID</p>
                  <p className="value">{plan._id}</p>
                </Col>

              </Row>

            </Card.Body>

          </Card>

          {/* LIMITS */}

          <Row className="mb-4">

            <Col md={4}>
              <Card className="limit-card">
                <Card.Body>
                  <FontAwesomeIcon icon={faUsers} className="limit-icon" />
                  <h4>{users}</h4>
                  <p>Max Candidates</p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="limit-card">
                <Card.Body>
                  <FontAwesomeIcon icon={faFileAlt} className="limit-icon" />
                  <h4>{exams}</h4>
                  <p>Max Exams</p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="limit-card">
                <Card.Body>
                  <FontAwesomeIcon icon={faUserTie} className="limit-icon" />
                  <h4>{proctors}</h4>
                  <p>Max Proctors</p>
                </Card.Body>
              </Card>
            </Col>

          </Row>

          {/* FEATURES */}

          <Card className="modal-section-card">

            <Card.Body>

              <h6 className="section-title mb-3">
                AI Features Access
              </h6>

              <div className="feature-grid">

                {plan.features?.map((feature: string, index: number) => (

                  <Badge
                    key={index}
                    className="feature-badge active-feature"
                  >
                    {feature.replace(/_/g, " ")}
                  </Badge>

                ))}

              </div>

            </Card.Body>

          </Card>

        </Card.Body>
      </Card>
    </div>
  );
};

export default ViewPlan;